import { EMPLOYEE_LEAVE_TYPE } from 'constants';
import { LETTER_TYPE_API } from 'constants';
import { EMPLOYEE_LEAVE_POLICY } from 'constants';
import { prefillUrl } from 'utils/StringUtils';


export const getEmployeeLeavePolicy = async (query) => {
    try {
        const authtoken = sessionStorage.getItem("token")
        let url = EMPLOYEE_LEAVE_POLICY;

        if (query) {
            url = prefillUrl(url);
            url = `${url}${query}`;
        }

        const requestOptions = {
            method: 'GET',
            headers: { 'Authorization': `token ${authtoken}` },
        };

        return await fetch(url, requestOptions).then((response) => response.json()).then(data => data);
    } catch (error) {
        return { status: "fail", message: error.message };
    }
}

export const getEmployeeAllLeavePolicy = async (query) => {
    try {
        const authtoken = sessionStorage.getItem("token")
        let url = EMPLOYEE_LEAVE_POLICY;

        if (query) {
            url = prefillUrl(url);
            url = `${url}drop_down=${query}`;
        }
        const requestOptions = {
            method: 'GET',
            headers: { 'Authorization': `token ${authtoken}` },
        };

        return await fetch(url, requestOptions).then((response) => response.json()).then(data => data);
    } catch (error) {
        return { status: "fail", message: error.message };
    }
}

export const getEmployeeAllLeaveType = async (query) => {
    try {
        const authtoken = sessionStorage.getItem("token")
        let url = EMPLOYEE_LEAVE_TYPE;

        if (query) {
            url = prefillUrl(url);
            url = `${url}drop_down=${query}`;
        }
        const requestOptions = {
            method: 'GET',
            headers: { 'Authorization': `token ${authtoken}` },
        };

        return await fetch(url, requestOptions).then((response) => response.json()).then(data => data);
    } catch (error) {
        return { status: "fail", message: error.message };
    }
}

export const getEmployeeLeavePolicyPagination = async ({ pageNo, pageSize, query, search, sorting }) => {
    try {
        const authtoken = sessionStorage.getItem("token")
        let url = EMPLOYEE_LEAVE_POLICY;

        if (pageNo) {
            url = prefillUrl(url);
            url = `${url}page_no=${pageNo}`;
        }

        if (pageSize) {
            url = prefillUrl(url);
            url = `${url}&page_size=${pageSize}`;
        }

        if (query) {
            url = prefillUrl(url);
            url = `${url}&${query}`;
        }

        if (search) {
            url = prefillUrl(url);
            url = `${url}&search=${search}`;
        }

        if (sorting) {
            url = prefillUrl(url);
            url = `${url}&${sorting}`;
        }

        const requestOptions = {
            method: 'GET',
            headers: { 'Authorization': `token ${authtoken}` },
        };

        return await fetch(url, requestOptions).then((response) => response.json()).then(data => data);
    } catch (error) {
        return { status: "fail", message: error.message };
    }
}

export const getEmployeeLeavePolicyById = async (id) => {
    try {
        const authtoken = sessionStorage.getItem("token")
        const requestOptions = {
            method: 'GET',
            headers: { 'Authorization': `token ${authtoken}` },

        };

        return await fetch(EMPLOYEE_LEAVE_POLICY + `?id=${id}`, requestOptions).then((response) => response.json()).then(data => data);
    } catch (error) {
        return { status: "fail", message: error.message };
    }
}

export const updateEmployeeDesignation = async (input) => {
    try {
        const authtoken = sessionStorage.getItem("token")
        const requestOptions = {
            method: 'PUT',
            headers: { 'Authorization': `token ${authtoken}` },
            body: JSON.stringify(input)
        };

        return await fetch(EMPLOYEE_LEAVE_POLICY, requestOptions).then((response) => response.json()).then(data => data);
    } catch (error) {
        return { status: "fail", message: error.message };
    }
}

export const getLetterTypePagination = async ({ pageNo, pageSize, query, search, sorting }) => {
    try {
        const authtoken = sessionStorage.getItem("token")
        let url = LETTER_TYPE_API;

        if (pageNo) {
            url = prefillUrl(url);
            url = `${url}page_no=${pageNo}`;
        }

        if (pageSize) {
            url = prefillUrl(url);
            url = `${url}&page_size=${pageSize}`;
        }

        if (query) {
            url = prefillUrl(url);
            url = `${url}&${query}`;
        }

        if (search) {
            url = prefillUrl(url);
            url = `${url}&search=${search}`;
        }

        if (sorting) {
            url = prefillUrl(url);
            url = `${url}&${sorting}`;
        }

        const requestOptions = {
            method: 'GET',
            headers: { 'Authorization': `token ${authtoken}` },
        };

        return await fetch(url, requestOptions).then((response) => response.json()).then(data => data);
    } catch (error) {
        return { status: "fail", message: error.message };
    }
}